import { AgsResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { AgsWin, AgsWinTypes } from "ags/integration/schema/ags-spin-response-schema";
import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export class PickTriggerResultBuilder extends AgsResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const win = data as AgsWin;
        return win.evaluationType && win.evaluationType.toLowerCase() === AgsWinTypes.RANDOM;
    }

    public build(record: Record, data: any): Result[] {
        const agsWin = data as AgsWin;
        return [new BonusResult(agsWin.featureType)];
    }
}
